import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoNotDisturbOnTotalSilenceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"do_not_disturb_on_total_silence"}/>
}
